import React from "react";

const index = () => {
  return (
    <div>
      <section className="privacyPolicy">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-sm-12">
              <div className="privacy_content">
                <h1>Terms and Conditions</h1>

                <h3>1. Third-Party Links & Partner Platform</h3>
                <p>
                  The Site contains links to third-party websites, including our
                  partner’s platform. We are not responsible for the content,
                  privacy practices, or terms of any third-party site. Once you
                  leave our Site, these Terms and our Privacy Policy no longer
                  apply.
                </p>
                <h3>2. Disclaimer of Warranties</h3>
                <p>
                  THE SITE IS PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT ANY
                  WARRANTIES OF ANY KIND.WE DISCLAIM ALL WARRANTIES, EXPRESS OR
                  IMPLIED, INCLUDING BUT NOT LIMITED TO ACCURACY,
                  NON-INFRINGEMENT, MERCHANTABILITY, AND FITNESS FOR A
                  PARTICULAR PURPOSE.
                </p>
                <h3>3. Limitation of Liability</h3>
                <p>
                  TO THE MAXIMUMEXTENT PERMITTED BY LAW, WE WILL NOT BE LIABLE
                  FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
                  PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUE, EVEN IF
                  ADVISED OF THE POSSIBILITY.
                </p>
                <h3>4. Indemnification</h3>
                <p>
                  You agree to indemnify and hold us harmless from any claims,
                  losses, or damages arising from your violation of these Terms
                  or your use of the Site.
                </p>

                <h3>5. Governing Law</h3>
                <p>
                  These Terms are governed by the laws of the State of [Your
                  State], without regard to conflict of law principles.
                </p>
                <h3>6. Changes to These Terms</h3>
                <p>
                  We may update these Terms at any time. The new version will be
                  posted here with an updated effective date.
                </p>
                <h3>7. Changes to These Terms</h3>
                <p>Questions? Email us at: mysha@tipcreditusa.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default index;
